export enum Formatter {
  YAML = 'yaml',
  JSON = 'json',
}
